import { render, staticRenderFns } from "./deleteHousekeepingServFeeConfigRel.vue?vue&type=template&id=ace31102"
import script from "./deleteHousekeepingServFeeConfigRel.vue?vue&type=script&lang=js"
export * from "./deleteHousekeepingServFeeConfigRel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports